import React, { FC } from "react";
import { format, parseISO } from "date-fns";
import { TaskExecution } from "shared/api";
import { OverviewThisWeekTaskAssigneeAvatar } from "./OverviewThisWeekTaskAssigneeAvatar";
import { OverviewThisWeekTaskStatusMark } from "./OverviewThisWeekTaskStatusMark";

interface Props {
  execution: TaskExecution;
  machinesNaLabel: string;
  unnamedTaskLabel: string;
}

const OverviewThisWeekTaskRow: FC<Props> = ({
  execution,
  machinesNaLabel,
  unnamedTaskLabel,
}) => {
  const title =
    execution.task?.name?.trim() ||
    execution.message?.trim() ||
    unnamedTaskLabel;

  const user = typeof execution.user === "number" ? null : execution.user;

  const subtitle = `${format(
    parseISO(execution.timestamp_expected),
    "MMM d"
  )} ${execution.machine?.name ?? machinesNaLabel}`;

  return (
    <li className="flex items-center gap-3 border-b border-neutral-100 px-3 py-2.5 last:border-b-0">
      <OverviewThisWeekTaskStatusMark status={execution.status} />
      <div className="min-w-0 flex-1">
        <div className="truncate text-sm font-semibold text-neutral-900">
          {title}
        </div>
        <div className="truncate text-xs text-neutral-500">{subtitle}</div>
      </div>
      <OverviewThisWeekTaskAssigneeAvatar user={user} />
    </li>
  );
};

export { OverviewThisWeekTaskRow };
